import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-calander',
  templateUrl: './calander.component.html',
  styleUrls: ['./calander.component.css']
})
export class CalanderComponent implements OnInit {
  ResultData:any=[];
  
  constructor( private router: Router,
    public global: GlobalService,
    private route: ActivatedRoute,
    private messageService: MessageService) { }

  ngOnInit(): void {
    this.getResults();
  }


  getResults() {
    const url =
      this.global.basePath +
      "common/circularlist?modelType=calendar";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.ResultData = data;
    });
  }

  openCalendar(url){
    window.open(url,'_blank')
  }
}
